// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2rPM5","savePackageButton":"ClientWallet_savePackageButton__1iuV5"};